// Callers announce intent; form-contact-rep.js owns the modal and the form.
// Keeping it one-way means the CTA components do not pull axios, Pristine and
// form-find-rep into their bundles just to open a modal.
export const CONTACT_REP_HASH = '#contact-rep';
export const CONTACT_REP_OPEN_EVENT = 'contact-rep:open';

export const openContactRepModal = () => {
  document.dispatchEvent(new CustomEvent(CONTACT_REP_OPEN_EVENT));
};
